exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".vapp-container .description-box {\n  border-top: 1px solid #eee;\n  border-bottom: 1px solid #eee;\n  margin: 0 0 0 0;\n  padding: 10px 5px; }\n\n.vapp-container .vapp-manage-vcloud div {\n  border-bottom: 1px solid #eee;\n  padding: 8px 0; }\n\n.vapp-service-unavailable {\n  margin: 10px 10px 20px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/components/compute/compute-vcd/vapp/vapp.scss
// module id = l2Lu
// module chunks = 0